import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-12 sm:py-16 px-4 bg-brand-forest text-white" data-id="element-48">
      <div className="max-w-3xl mx-auto text-center" data-id="element-49">
        <h2 className="text-3xl sm:text-5xl font-serif font-bold mb-4" data-id="element-50">
          Stop Wondering What to Eat.
        </h2>
        <p className="text-lg sm:text-xl mb-8" data-id="element-51">
          Discover delicious recipes, simplify your meals and enjoy a more
          organized way of eating.
        </p>

        <div className="bg-white/10 border-2 border-white/20 rounded-xl p-6 mb-6" data-id="element-52">
          <p className="text-sm uppercase tracking-wide mb-2" data-id="element-53">
            THE THYROID RESET COOKBOOK™
          </p>
          <p className="text-5xl font-serif font-bold mb-2" data-id="element-54">ONLY $27 USD</p>
        </div>

        <CTAButton href="https://thyroidreset.impultienda.ar/checkout" className="max-w-md mx-auto" data-id="element-55">
          YES! I WANT INSTANT ACCESS NOW
        </CTAButton>
      </div>
    </section>;
}